import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserForm from '../UserForm';
import { backToUsers } from './navigation';
import AdminHeader from './AdminHeader';

const EditUser = ({ isRestrictedUser, ...props }) => {
  const back = () => backToUsers(props.campaignId, { isRestrictedUser });
  return (
    <>
      <AdminHeader title="Edit User" onBack={back} />
      <UserForm
        {...props}
        screen="edit"
        submitLabel="Save"
        showCancel
        showCreateAnother={false}
        onCancel={back}
      />
    </>
  );
};

EditUser.propTypes = { campaignId: PropTypes.string, isRestrictedUser: PropTypes.bool };

const mapStateToProps = (state) => ({ isRestrictedUser: state.AppUser.isRestrictedUser === true });

export default connect(mapStateToProps)(EditUser);
